import React, { useEffect, useState } from "react";
import { Card, Col, Container, Form, Row } from "react-bootstrap";
import ModeWiseEIWRSGraph from "./ModeWiseEIWRSGraph";
import EIWRSRecentActivity from "./EIWRSRecentActivity";
import { BiSolidDashboard } from "react-icons/bi";
import UseToggle from "../../../Hooks/UseToggle";
import AddComponents from "./AddComponents";
import { studyEDCDashboardGraph } from "../../../APIServices/studyEDCDashboardGraph";
import { useParams } from "react-router";
import { PageLoader } from "../../../Components/NoDataFoundTable/NoDataFoundTable";

const EIWRSDashboard = ({ tableRef, onMouseDown }) => {
  const toggles = UseToggle();
  const { studyId } = useParams();
  const [greeting, setGreeting] = useState("");
  const [selected, setSelected] = useState([]);
  const category = JSON.parse(localStorage.getItem("role"));
  const [dashboardLoader, setDashboardLoader] = useState(false);
  const userName = JSON.parse(localStorage.getItem("firstName"));
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));

  const getGreeting = () => {
    const currentTime = new Date().getHours();
    let greeting;
    if (currentTime >= 5 && currentTime < 12) greeting = "Good Morning";
    else if (currentTime >= 12 && currentTime < 18) greeting = "Good Afternoon";
    else greeting = "Good Evening";
    setGreeting(greeting);
  };

  const getStudyDashboardComponentData = async () => {
    setDashboardLoader(true);
    let data = await studyEDCDashboardGraph.getStudyDashboardComponentData(
      studyId,
      category,
      StudyMode
    );
    setSelected(data?.data || []);
    setDashboardLoader(false);
  };

  useEffect(() => {
    getGreeting();
    getStudyDashboardComponentData();
  }, [studyId]);

  return (
    <>
      <div className="chart__overview">
        <div className="hstack gap-2 p-1 justify-content-end border-bottom">
          <button
            title="Edit Chart"
            className="updateProfile hstack gap-1"
            onClick={() => toggles.setToggle3()}
          >
            <BiSolidDashboard /> Add Component
          </button>
        </div>
        <div className="text-center py-2 border-bottom">
          <h5 className="m-0">
            {greeting}! {userName}
          </h5>
          <p className="m-0">Welcome to Your eIWRS Dashboard.</p>
        </div>
        {dashboardLoader ? (
          <PageLoader />
        ) : (
          <Container fluid>
            <Row>
              <Form.Group
                as={Col}
                md={selected.includes("Recent activity") ? 8 : 12}
                className={"overflow-auto border-end pt-2 p-0"}
                style={{ height: "calc(100vh - 245px)" }}
              >
                <ModeWiseEIWRSGraph
                  selected={selected}
                  StudyMode={StudyMode}
                />
              </Form.Group>
              {selected.includes("Recent activity") && (
                <Form.Group as={Col} sm={4} className="pt-2">
                  <Card className="app-card border bg-light">
                    <Card.Body>
                      <Card.Title>Recent activity</Card.Title>
                      <Card.Text className="m-0 mt-2">
                        <div
                          className="overflow-auto"
                          style={{ height: "calc(100vh - 325px)" }}
                        >
                          <EIWRSRecentActivity StudyMode={StudyMode} />
                        </div>
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </Form.Group>
              )}
            </Row>
          </Container>
        )}
        <AddComponents
          Show={!toggles.toggle3}
          Hide={toggles.setToggle3}
          tableRef={tableRef}
          onMouseDown={onMouseDown}
          studyId={studyId}
          category={category}
          StudyMode={StudyMode}
          selected={selected}
          setSelected={setSelected}
          getStudyDashboardComponentData={getStudyDashboardComponentData}
        />
      </div>
    </>
  );
};

export default EIWRSDashboard;
